<template>
  <section class="section-container targets-bg">
    <h2 class="section-title">{{ $t('home-page.Target.title') }}</h2>
    <div class="targets-grid">
      <div class="target-item" data-aos="zoom-in">
        <p>{{ $t('home-page.Target.targets[0]') }}</p>
      </div>
      <div class="target-item" data-aos="zoom-in" data-aos-delay="50">
        <p>{{ $t('home-page.Target.targets[1]') }}</p>
      </div>
      <div class="target-item" data-aos="zoom-in" data-aos-delay="100">
        <p>{{ $t('home-page.Target.targets[2]') }}</p>
      </div>
      <div class="target-item" data-aos="zoom-in" data-aos-delay="150">
        <p>{{ $t('home-page.Target.targets[3]') }}</p>
      </div>
      <div class="target-item" data-aos="zoom-in" data-aos-delay="200">
        <p>{{ $t('home-page.Target.targets[4]') }}</p>
      </div>
      <div class="target-item" data-aos="zoom-in" data-aos-delay="250">
        <p>{{ $t('home-page.Target.targets[5]') }}</p>
      </div>
    </div>
  </section>
</template>

<style scoped>
.targets-bg {
  background-color: #f8f9fa;
}
.targets-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1100px;
  margin: 0 auto;
}
.target-item {
  background-color: #fff;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 150px;
}
.target-item p {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 500;
  color: #333;
}
@media (max-width: 768px) {
  .target-item {
    min-height: 120px;
  }
  .target-item p {
    font-size: 1rem;
  }
}
</style>